import { useActorRef } from '@xstate5/react';
import { otaMachine } from '@sg/ota-installer';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { otaLogger } from './helpers';

// ─────────────────────────────────────────────────────────────────────────────

export const useInitOtaActor = () => {
  const pollingIntervalInMinutes = useFeatureFlag(
    'CELS-4466-order-in-app-ota-polling-interval',
  );

  return useActorRef(
    otaMachine.provide({
      delays: { POLLING_INTERVAL: pollingIntervalInMinutes * 60 * 1000 },
    }),
    { input: { logger: otaLogger } },
  );
};
